<div class="wrapper relative" [ngClass]="{ active: flyoutVisible }">
	<i class="ico ico-search"></i>
	<input
		#searchInput
		type="search"
		class="search"
		[placeholder]="'search.input.placeholder' | translate"
		autocomplete="off"
		[(ngModel)]="searchTerm"
		(focus)="onFocus()"
		(click)="preventClosingFlyout($event)"
		(keyup)="onKeyUp($event)"
		(keydown.escape)="$event.preventDefault()"
		maxlength="1337"
	/>
</div>

@if (searching) {
	<div class="progress">
		<div class="indeterminate"></div>
	</div>
}
@if (overviewResults) {
	<div [hidden]="(!isSearchOpen && isMobileView) || !flyoutVisible" class="search-flyout">
		@if (overviewResults && !overviewResults.error && workspaces) {
			<div class="wrapper">
				@if (overviewResults?.suggestions?.length) {
					<ul class="suggestions">
						@for (suggestion of overviewResults?.suggestions; track suggestion; let index = $index) {
							<li [ngClass]="{ selected: isSelected(overviewResults, Subsection.Suggestions, index) }">
								<span class="cell">
									@if (!isFile(suggestion)) {
										<a
											class="clickable"
											[routerLink]="buildElementRouterLink(workspaces, suggestion)"
											(click)="closeSearch()"
										>
											<span [ngClass]="{ tailored: suggestion.tailored }">{{ suggestion.label }} </span>
											<span>({{ suggestion.type.name }})</span>
											@if (searchScope !== "local") {
												<span class="workspace-name"> [{{ suggestion.workspaceName }}]</span>
											}
										</a>
									}
									@if (isFile(suggestion)) {
										<a
											class="clickable"
											(click)="
												downloadFileFromSearchSuggestion(suggestion, workspaces.currentWorkspace.id); closeSearch()
											"
											(stagesKeyUp)="onKeyUpForFileSearchResult($event, suggestion, workspaces.currentWorkspace.id)"
										>
											<span class="ico" [ngClass]="getFileIconClass(suggestion)"></span>
											<span [ngClass]="{ tailored: suggestion.tailored }">{{ suggestion.label }} </span>
											<span>({{ suggestion.type.name }})</span> </a
										>&nbsp; <span translate="search.flyout.search.at.container"></span>&nbsp;
										<a
											class="clickable"
											[routerLink]="buildFileContainerRouterLink(workspaces, suggestion)"
											(click)="closeSearch()"
										>
											<span>{{ suggestion.containerElementName }}</span>
											@if (searchScope !== "local") {
												<span class="workspace-name"> [{{ suggestion.workspaceName }}]</span>
											}
										</a>
									}
								</span>
							</li>
						}
						@if (overviewResults?.suggestions?.length) {
							<li [ngClass]="{ selected: isSelected(overviewResults, Subsection.MoreLink, 0) }">
								<span class="cell">
									<a class="clickable" (click)="openResults('local'); closeSearch()">
										<span class="ico ico-more-horizontal"></span>
										<span translate="search.result.openMoreResults"></span>
									</a>
								</span>
							</li>
						}
					</ul>
				}
				@if (overviewResults?.type_aggregations?.length) {
					<ul class="aggregations">
						@for (aggregation of overviewResults?.type_aggregations; track aggregation; let index = $index) {
							<li [ngClass]="{ selected: isSelected(overviewResults, Subsection.TypeAggregations, index) }">
								<span class="cell">
									<a (click)="openResults(searchScope, [aggregation.key]); closeSearch()">
										<span class="term">{{ searchTerm }} </span>
										<span
											class="category"
											translate="search.flyout.search.in"
											[translateParams]="{ category: aggregation.key }"
										></span>
										<span class="counter">~&nbsp;{{ aggregation.doc_count }}</span>
									</a>
								</span>
							</li>
						}
					</ul>
				}
				<ul class="other">
					@if (!overviewResults.error && !hasResults()) {
						<li class="not-clickable">
							<span class="cell">
								<a translate="search.flyout.no.results" [translateParams]="{ term: searchTerm }"></a>
							</span>
						</li>
					}
					@if (searchScope !== "local" && hasResults()) {
						<li [ngClass]="{ selected: isSelected(overviewResults, Subsection.ExtendRestrictLink, 0) }">
							<span class="cell">
								<a
									class="clickable"
									(click)="openResults('local'); closeSearch()"
									translate="search.flyout.search.current"
								></a>
							</span>
						</li>
					}
					@if (searchScope !== "all" && hasResultsInOtherWorkspaces()) {
						<li [ngClass]="{ selected: isSelected(overviewResults, Subsection.ExtendRestrictLink, 0) }">
							<span class="cell">
								<a
									class="clickable"
									(click)="openResults('all'); closeSearch()"
									translate="search.flyout.search.all"
								></a>
							</span>
						</li>
					}
				</ul>
			</div>
		}
		@if (!searchEngineAvailable) {
			<div class="wrapper">
				<ul>
					<li class="label"><span translate="search.notavailable"></span></li>
				</ul>
			</div>
		}
	</div>
}
